export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/CoinIcon-d2bdfe192c76c0136cc4aec80aa1dd56.png";